import type { Theme } from '@mui/material';

export const styles = {
  backToDashboard: (theme: Theme) => ({
    fontSize: 16,
    fontWeight: 700,
    color: theme.colors.primary[500],
    ml: '1.5rem',
  }),
};
